module.exports = __webpack_public_path__ + "static/media/logo_svasek.6941822c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_svasek.png
// module id = 241
// module chunks = 0